import store from '@/store'
/**
 * @name: 区分登陆角色，返回相应类名及其图片
 * @parpams {string} 角色id
 * @return {string} 角色类名
 */
export function roleFilterClass(){
  switch (store.state.region) {
    case 1:
      return "jc"
      break;
    case 4:
      return "lf"
      break;
    case 5:
      return "al"
      break;
    default:
      break;
   }
}

/**
 * @name: 区分登陆角色，返回角色
 * @parpams {string} 角色id
 * @return {string}  名字
 */
export function roleFilterText(){
  switch (store.state.region) {
    case 1:
      return "晋城市"
      break;
    case 4:
      return "临汾市"
      break;
    case '5':
      return ""
      break;
    default:
      return ""
      break;
   }
}


/**
 * @name: 区分登陆角色，返回教育局通知文件
 * @parpams {string} 角色id
 * @return {string}  教育局通知文件
 */
 export function roleFilterFile() {
  switch (store.state.region) {
    case 1:
      return "山西省教育厅关于举办2022年山西省职业院校-教学能力比赛通知.pdf";
      break;
    case 4:
      return "山西省教育厅关于举办2022年山西省职业院校-教学能力比赛通知.pdf";
      break;
    default:
      break;
  }
}